import LocalStorageManager from './localStorageManager'
import {limits} from './limits'
import Customer from './customer'
import plans from '../data/plans.json'
import usageLimits from '../data/usageLimits.json'
import localStorageKeys from './localStorageKeys'

const ENABLED_LIMIT_KEY = 'enabled'
const ENABLED_LIMIT_VALUE = 1
const TEST_ALERT_COUNT = 3
const BUSINESS_PLAN_KEY = 'business#v1'
const PLAN = 'plan'
class LimitManager {
    #getLimitByKey = key => {
        let overriddenLimits = LocalStorageManager.get(limits.overriddenLimits) || []
        overriddenLimits = overriddenLimits?.find(item => item?.key === key)?.value
        const userLimits = LocalStorageManager.get(limits.limits)?.find(item => item?.key === key)?.value
        return overriddenLimits || userLimits || 0
    }

    #isLimitEnabled = key => {
        if (this.isBusinnesPlan) {
            return true
        }
        return this.#getLimitByKey(key) === ENABLED_LIMIT_VALUE
    }

    isPaidPlan = () => localStorage.getItem(PLAN) !== plans.free_v1.key
    isBusinnesPlan = localStorage.getItem(PLAN) === BUSINESS_PLAN_KEY
    isTrialPeriod = () => Customer.isRoot() && this.isPaidPlan() && LocalStorageManager.get(localStorageKeys.TRIAL)

    getResourceLimit = () => this.#getLimitByKey(usageLimits.limit_keys.resource_count.limit_key)
    getServerResourceLimit = () => this.#getLimitByKey(usageLimits.limit_keys.server_resource_count.limit_key)
    getSMSChannelLimit = () => this.#getLimitByKey(usageLimits.limit_keys.per_user_sms_channel_count.limit_key)
    getTeamMemberLimit = () => this.#getLimitByKey(usageLimits.limit_keys.team_member_count.limit_key)
    getTLDReminderIsEnabled = () => this.#isLimitEnabled(usageLimits.limit_keys.tld_reminder_enabled.limit_key)
    getSMSChannelIsEnabled = () => this.#isLimitEnabled(usageLimits.limit_keys.sms_channel_enabled.limit_key)
    getSlackChannelIsEnabled = () => this.#isLimitEnabled(usageLimits.limit_keys.slack_channel_enabled.limit_key)
    getOnCallScheduleIsEnabled = () => this.#isLimitEnabled(usageLimits.limit_keys.on_call_enabled.limit_key)
    getWebhookIsEnabled = () => this.#isLimitEnabled(usageLimits.limit_keys.webhook_enabled.limit_key)
    getSlackChannelLimit = () => this.#getLimitByKey(usageLimits.limit_keys.slack_channel_count.limit_key)
    getWebhookChannelIsEnabled = () => this.#isLimitEnabled(usageLimits.limit_keys.webhook_channel_enabled.limit_key)
    getWebhookChannelLimit = () => this.#getLimitByKey(usageLimits.limit_keys.per_user_webhook_channel_count.limit_key)
    getMSTeamsChannelIsEnabled = () => this.#isLimitEnabled(usageLimits.limit_keys.ms_teams_channel_enabled.limit_key)
    getMSTeamsChannelLimit = () => this.#getLimitByKey(usageLimits.limit_keys.ms_teams_channel_count.limit_key)
    getDiscordChannelIsEnabled = () => this.#isLimitEnabled(usageLimits.limit_keys.discord_channel_enabled.limit_key)
    getDiscordChannelLimit = () => this.#getLimitByKey(usageLimits.limit_keys.discord_channel_count.limit_key)
    getServiceLimit = () => this.#getLimitByKey(usageLimits.limit_keys.service_count.limit_key)
    getStateDescIsEnabled = () => this.#isLimitEnabled(usageLimits.limit_keys.state_description_enabled.limit_key)
    getRegionLimit = () => this.#getLimitByKey(usageLimits.limit_keys.region_count.limit_key)
    getTeamMemberInvitationIsEnabled = () => this.#isLimitEnabled(usageLimits.limit_keys.team_member_invitation_enabled.limit_key)
    getSSLReminderIsEnabled = () => this.#isLimitEnabled(usageLimits.limit_keys.ssl_reminder_enabled.limit_key)
    getHeartbeatLimit = () => this.#getLimitByKey(usageLimits.limit_keys.heartbeat_count.limit_key)
    getTestAlertCount = () => TEST_ALERT_COUNT
    getHeartbeatMonitoringIsEnabled = () => this.#isLimitEnabled(usageLimits.limit_keys.heartbeat_monitoring_enabled.limit_key)
    getKeywordMonitoringIsEnabled = () => this.#isLimitEnabled(usageLimits.limit_keys.keyword_monitoring_enabled.limit_key)
    getPingMonitoringIsEnabled = () => this.#isLimitEnabled(usageLimits.limit_keys.ping_monitoring_enabled.limit_key)
    getAdvancedMonitoringIsEnabled = () => this.#isLimitEnabled(usageLimits.limit_keys.advanced_monitoring_enabled.limit_key)
    getConditionMonitoringIsEnabled = () => this.#isLimitEnabled(usageLimits.limit_keys.condition_monitoring_enabled.limit_key)
    getEmailMonitoringIsEnabled = () => this.#isLimitEnabled(usageLimits.limit_keys.email_monitoring_enabled.limit_key)
    getTeamLimit = () => this.#getLimitByKey(usageLimits.limit_keys.team_count.limit_key)
    getIntegrationLimit = () => this.#getLimitByKey(usageLimits.limit_keys.integration_count.limit_key)
    getPortMonitoringIsEnabled = () => this.#isLimitEnabled(usageLimits.limit_keys.port_monitoring_enabled.limit_key)
    getStatusPageLogoEnabled = () => this.#isLimitEnabled(usageLimits.limit_keys.statuspage_logo_enabled.limit_key)
    getStatusPageGaTrackingEnabled  = () => this.#isLimitEnabled(usageLimits.limit_keys.statuspage_ga_tracking_enabled.limit_key)
    getStatusPageSubscriptionEnabled  = () => this.#isLimitEnabled(usageLimits.limit_keys.statuspage_subscription_enabled.limit_key)
    getStatusPageSubscriptionsCount  = () => this.#getLimitByKey(usageLimits.limit_keys.statuspage_subscription_count.limit_key)
    getStatusPagePrivatePageEnabled  = () => this.#isLimitEnabled(usageLimits.limit_keys.statuspage_private_page_enabled.limit_key)
    getStatusPageDomainEnabled  = () => this.#isLimitEnabled(usageLimits.limit_keys.statuspage_domain_enabled.limit_key)
    getStatusPageBrandingRemovedEnabled  = () => this.#isLimitEnabled(usageLimits.limit_keys.statuspage_branding_removed_enabled.limit_key)
    getStatusPageRobotMetaContentsEnabled  = () => this.#isLimitEnabled(usageLimits.limit_keys.statuspage_robot_meta_contents_enabled.limit_key)
    getStatusPagesLimit = () => this.#getLimitByKey(usageLimits.limit_keys.statuspage_count.limit_key)

    getAllLimits = () => LocalStorageManager.get(limits.limits)

    getLimitDiff = (key, value) => {
        return this.#getLimitByKey(key) - value < 0 ? 0 : this.#getLimitByKey(key) - value
    }

    getLimitUsages = (module, key, orgUsageLimits) => {
        return orgUsageLimits?.[module]?.find(orgUsageLimit => orgUsageLimit?.key === key)
    }
}

export {
    ENABLED_LIMIT_KEY,
    ENABLED_LIMIT_VALUE
}

export default new LimitManager()
